import { DefaultButton } from './Button';
import createTagButton from '../../../utils/helpers/createTagButton';

const GrayCommonBtn = createTagButton(DefaultButton, { forwardEvent: false });

export default GrayCommonBtn;
